<template>
  <svg width="135" height="164" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M67.56 8.821c37.248 0 67.44 30.195 67.44 67.44S104.806 143.7 67.56 143.7C30.316 143.7.12 113.508.12 76.263S30.316 8.821 67.56 8.821Z"
      fill="#FAF8FF"
    />
    <mask
      id="a"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="8"
      width="135"
      height="136"
    >
      <path
        d="M67.56 8.821c37.248 0 67.44 30.195 67.44 67.44S104.806 143.7 67.56 143.7C30.316 143.7.12 113.508.12 76.263S30.316 8.821 67.56 8.821Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#a)" fill="#433860">
      <path
        d="M126.814 14.336a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM126.814 29.82a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM126.814 45.305a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM126.814 60.79a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.29ZM126.814 76.273a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM126.814 91.758a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM126.814 107.242a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM126.814 122.727a.646.646 0 1 0-.001-1.291.646.646 0 0 0 .001 1.291ZM126.814 138.211a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM111.33 14.336a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM111.33 29.82a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM111.33 45.305a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM111.33 60.79a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.29ZM111.33 76.273a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM111.33 91.758a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM111.33 107.242a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM111.33 122.727a.646.646 0 1 0-.001-1.291.646.646 0 0 0 .001 1.291ZM111.33 138.211a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM95.845 14.336a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM95.845 29.82a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM95.845 45.305a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM95.845 60.79a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.29ZM95.845 76.273a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM95.845 91.758a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM95.845 107.242a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM95.845 122.727a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.291ZM95.845 138.211a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM80.361 14.336a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM80.361 29.82a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM80.361 45.305a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM80.361 60.79a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.29ZM80.361 76.273a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM80.361 91.758a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM80.361 107.242a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM80.361 122.727a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM80.361 138.211a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM64.877 14.336a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM64.877 29.82a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM64.877 45.305a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM64.877 60.79a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.29ZM64.877 76.273a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM64.877 91.758a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM64.877 107.242a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM64.877 122.727a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM64.877 138.211a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM49.392 14.336a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM49.392 29.82a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM49.392 45.305a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM49.392 60.79a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.29ZM49.392 76.273a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM49.392 91.758a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM49.392 107.242a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM49.392 122.727a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.291ZM49.392 138.211a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM33.908 14.336a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM33.908 29.82a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM33.908 45.305a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM33.908 60.79a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.29ZM33.908 76.273a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM33.908 91.758a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM33.908 107.242a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM33.908 122.727a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM33.908 138.211a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM18.424 14.336a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM18.424 29.82a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM18.424 45.305a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM18.424 60.79a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.29ZM18.424 76.273a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM18.424 91.758a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM18.424 107.242a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM18.424 122.727a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM18.424 138.211a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM2.94 14.336a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM2.94 29.82a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM2.94 45.305a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM2.94 60.79a.645.645 0 1 0 0-1.291.645.645 0 0 0 0 1.29ZM2.94 76.273a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM2.94 91.758a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM2.94 107.242a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM2.94 122.727a.645.645 0 1 0-.001-1.29.645.645 0 0 0 0 1.29ZM2.94 138.211a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29Z"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m84.402 55.772 39.754 12.308a3.475 3.475 0 0 1 2.292 4.35L102.341 150.3a3.474 3.474 0 0 1-4.349 2.292L58.24 140.283a3.477 3.477 0 0 1-2.294-4.348L80.05 58.066a3.473 3.473 0 0 1 4.349-2.291l.002-.003Z"
      fill="#FFC57E"
    />
    <g filter="url(#b)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m85.558 59.24 39.754 12.308a3.475 3.475 0 0 1 2.292 4.351l-24.107 77.868a3.474 3.474 0 0 1-4.348 2.292l-39.754-12.307c-1.835-.568-4.976-.581-3.45-7.82l25.262-74.397a3.477 3.477 0 0 1 4.349-2.294h.002Z"
        fill="#FFC57E"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m84.402 55.772 39.754 12.308a3.475 3.475 0 0 1 2.292 4.35L102.341 150.3a3.474 3.474 0 0 1-4.349 2.292L58.24 140.283a3.477 3.477 0 0 1-2.294-4.348L80.05 58.066a3.473 3.473 0 0 1 4.349-2.291l.002-.003Z"
      fill="url(#c)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M80.296 134.34a4.02 4.02 0 0 1 4.021 4.023 4.02 4.02 0 0 1-4.02 4.021 4.024 4.024 0 0 1-4.024-4.021 4.025 4.025 0 0 1 4.023-4.023Z"
      fill="#fff"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m79.403 44.603-6.157-6.697H41.658c-6.39 0-11.567-5.18-11.567-11.57V11.57C30.09 5.18 35.268 0 41.658 0h26.179c6.908 0 11.566 5.18 11.566 11.57v33.033Z"
      fill="#5B45D2"
    />
    <path
      d="M52.525 21.866v-1.083c0-.824.168-1.52.506-2.088.336-.568.934-1.12 1.791-1.66.681-.428 1.172-.815 1.471-1.16.3-.347.45-.742.45-1.188 0-.354-.16-.632-.481-.839-.32-.206-.736-.31-1.249-.31-1.27 0-2.756.45-4.454 1.35l-1.755-3.432c2.095-1.195 4.281-1.791 6.56-1.791 1.876 0 3.347.413 4.416 1.236 1.068.823 1.602 1.949 1.602 3.368 0 1.017-.237 1.9-.712 2.643-.475.743-1.234 1.447-2.276 2.113-.883.573-1.438.991-1.66 1.254a1.42 1.42 0 0 0-.335.94v.642h-3.874v.005Zm-.544 4.416c0-.774.224-1.37.676-1.79.449-.422 1.112-.63 1.987-.63s1.486.211 1.936.637c.449.426.676 1.02.676 1.786s-.233 1.357-.7 1.778c-.467.42-1.104.63-1.912.63-.808 0-1.484-.21-1.956-.625-.473-.416-.707-1.012-.707-1.786Z"
      fill="#3AFFD3"
    />
    <path
      fill="url(#pattern0_1865_1282)"
      d="M23.004 39.619H87.78v32.517H23.004z"
      style="mix-blend-mode: multiply"
    />
    <defs>
      <linearGradient
        id="c"
        x1="72.802"
        y1="136.879"
        x2="115.518"
        y2="60.941"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3AFFD3" />
        <stop offset="1" stop-color="#FFC57E" />
      </linearGradient>
      <filter
        id="b"
        x="53.217"
        y="57.794"
        width="80.48"
        height="105.391"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.807" dy="2.839" />
        <feGaussianBlur stdDeviation="2.065" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1865_1282"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1865_1282"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
